import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useDragScroll } from "../../hooks/useDragScroll";
import SubcategoryCard from "./SubcategoryCard";
import ScrollArrows from "./ScrollArrows";

/**
 * SubcategoryList Component
 * Displays a scrollable carousel of subcategories with drag functionality
 */
const SubcategoryList = ({
  subcategories,
  selectedSubcategory,
  onSubcategoryChange,
  selectedCategory,
  loading = false,
}) => {
  const { scrollContainerRef, isDragging, handlers, scroll } = useDragScroll();

  // Don't show if no subcategories or only "all" subcategory
  if (subcategories.length <= 1) {
    return null;
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 2,
          mb: 1.5,
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 1.5, position: "relative" }}>
      <ScrollArrows
        onScrollLeft={() => scroll("left")}
        onScrollRight={() => scroll("right")}
      />

      <Box
        ref={scrollContainerRef}
        {...handlers}
        sx={{
          display: "flex",
          gap: 1.5,
          overflowX: "auto",
          pb: 1,
          px: 2,
          scrollBehavior: "smooth",
          WebkitOverflowScrolling: "touch",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          cursor: isDragging ? "grabbing" : "grab",
          userSelect: "none",
        }}
      >
        {subcategories.map((subcategory) => (
          <SubcategoryCard
            key={subcategory.id}
            subcategory={subcategory}
            isSelected={selectedSubcategory === subcategory.id}
            onClick={() => onSubcategoryChange(subcategory.id)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SubcategoryList;
